export function getReportName(name) {
    const value = name.replaceAll("_"," ");
    return  value.replace(/\b\w/g, l => l.toUpperCase());
}